import { Form } from 'antd'
import * as React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Redirect, RouteChildrenProps, withRouter } from 'react-router'
import styled from 'styled-components'
import { AppRoutes, getRoute } from '../AppRoutes'
import { IApplicationState } from '../store/store'
import ForgotPasswordForm from './ForgotPasswordForm'
import LoginForm from './LoginForm'
import RedoxLogo from '../RedoxLogo'

const LoginContainer = styled.div`
	margin-top: 10vh;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`

interface IProps extends IStateProps, RouteChildrenProps<any, { from: string }> {
	history: any
	form: any
}

export const LoginLink = styled.p`
	font-size: 14px;
	color: #29c086;
	cursor: pointer;
	margin-top: 15px;
`

const FormsContainer = styled.div`
	position: relative;
	width: 100%;
	height: 500px;
	overflow-x: hidden;
`

const CenteredBox = styled.div`
	position: absolute;
	top: 0;
	left: 50%;
	transform: translateX(-50%);

	transition: all 0.5s ease-in-out;
	&.out-right {
		left: 200vw;
	}
	&.out-left {
		left: -200vw;
	}
`

const Login = (props: IProps) => {
	const [ out, setout ] = useState(false)

	let redirectTo = AppRoutes.MY_DIAGRAMS as string

	if (props.location && props.location.state && props.location.state.from) {
		redirectTo = props.location.state.from
	}

	return !props.isLoggedIn ? (
		<LoginContainer>
			<RedoxLogo width={500} />
			<FormsContainer>
				<CenteredBox className={out ? 'out-left' : ''}>
					<LoginForm onForgot={() => setout(true)} />
				</CenteredBox>
				<CenteredBox className={!out ? 'out-right' : ''}>
					<ForgotPasswordForm onLogin={() => setout(false)} />
				</CenteredBox>
			</FormsContainer>
		</LoginContainer>
	) : (
		<Redirect to={getRoute(redirectTo)} />
	)
}

interface IStateProps {
	isLoggedIn: boolean
}

const mapStateToProps = (state: IApplicationState): IStateProps => ({
	isLoggedIn: !!state.user.user
})

export default connect(mapStateToProps, null)(Form.create({ name: 'login' })(withRouter(Login)))
